import React, { useContext } from 'react'
import { Header } from 'semantic-ui-react'
import DefaultPanel from './DefaultPanel'
import ConnectPanel from './ConnectPanel'
import DataContext from '../../contexts/DataContext'

const StripePanel = () => {
  const { advisor } = useContext(DataContext)

  const { isConnected } = advisor.expert.stripeAccount

  const renderStripe = () => {
    if (isConnected) {
      return <ConnectPanel />
    }
    return <DefaultPanel />
  }
  return (
    <div>
      <Header as="h1" textAlign="center">
        {`You are ${isConnected ? '' : 'not '} connected to Stripe`}
      </Header>
      <Header as="h3" textAlign="center" style={{ marginTop: 0 }}>
        Set up payments with Stripe and start getting paid for your insights
      </Header>
      {renderStripe()}
      <div className="bank-section">
        <div className="connect-section">
          <div className="ui icon message stripe-message">
            <div className="content">
              We process payments via{' '}
              <a
                href="https://stripe.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stripe
              </a>
              , a global online payments processor trusted by Amazon, Google,
              Microsoft and thousands of other businesses. Stripe is extremely
              safe and secure, and you can read more about Stripe in the FAQ
              below. Please click the “Connect with Stripe” button to be taken
              to Stripe’s account set up page.
            </div>
            <img
              aria-hidden="true"
              src={`${process.env.REACT_APP_AWS_S3_URL}/stripe.png`}
              alt="stripe"
              id="stripe-message-icon"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StripePanel
